// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerF_TheComp__YthRF"};